export type SelectOption = {
  label: string;
  value: string | number;
};

export type MotionSensorPreset = {
  preset: string;
  motionTriggerSensitivity: string;
  autoReleaseDelay: string;
  vacancyCoolDown: number;
  autoBookingDuration: number;
};

export const customPresetDefaults: MotionSensorPreset = {
  preset: "custom",
  motionTriggerSensitivity: "responsive",
  autoReleaseDelay: "responsive",
  vacancyCoolDown: 5,
  autoBookingDuration: 15,
};

export const presetDefaults: Record<string, MotionSensorPreset> = {
  custom: customPresetDefaults,
  drop_in_space: {
    preset: "drop_in_space",
    motionTriggerSensitivity: "instant",
    autoReleaseDelay: "responsive",
    vacancyCoolDown: 5,
    autoBookingDuration: 15,
  },
  focus_team: {
    preset: "focus_team",
    motionTriggerSensitivity: "balanced",
    autoReleaseDelay: "cautious",
    vacancyCoolDown: 15,
    autoBookingDuration: 60,
  },
  executive: {
    preset: "executive",
    motionTriggerSensitivity: "conservative",
    autoReleaseDelay: "very_cautious",
    vacancyCoolDown: 15,
    autoBookingDuration: 120,
  },
};

export const presetOptions = [
  { title: "Custom", value: "custom" },
  { title: "Drop-In Space (1-4p)", value: "drop_in_space" },
  { title: "Focus/Team (4-12p)", value: "focus_team" },
  { title: "Executive (12+)", value: "executive" },
];

export const motionTriggerSensitivityOptions: SelectOption[] = [
  { label: "Instant", value: "instant" },
  { label: "Responsive", value: "responsive" },
  { label: "Balanced", value: "balanced" },
  { label: "Conservative", value: "conservative" },
];

export const autoReleaseDelayOptions: SelectOption[] = [
  { label: "Responsive", value: "responsive" },
  { label: "Balanced", value: "balanced" },
  { label: "Cautious", value: "cautious" },
  { label: "Very Cautious", value: "very_cautious" },
];

export const vacancyCoolDownOptions: SelectOption[] = [5, 10, 15].map(
  (value) => ({
    value,
    label: `${value} minutes`,
  })
);

export const autoBookingDurationOptions: SelectOption[] = [
  { label: "15 minutes", value: 15 },
  { label: "30 minutes", value: 30 },
  { label: "60 minutes", value: 60 },
  { label: "2 hours", value: 120 },
];
